import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  Typography
} from '@mui/material';

// Import all available PNG icons
import DashboardIcon from '../../../Assets/Icons/Dashboard.png';
import TuketimTakibiIcon from '../../../Assets/Icons/TuketimTakibi.png';
import PompaVeHidroforIcon from '../../../Assets/Icons/PompaVeHidrofor.png';
import IsitmaSistemleriIcon from '../../../Assets/Icons/IsitmaSistemleri.png';
import SogutmaSistemleriIcon from '../../../Assets/Icons/SogutmaSistemleri.png';
import EnerjiIcon from '../../../Assets/Icons/Enerji.png';
import VRFIcon from '../../../Assets/Icons/VRF.png';
import KlimaSantIcon from '../../../Assets/Icons/KlimaSant.png';
import RooftopIcon from '../../../Assets/Icons/Rooftop.png';
import TankIcon from '../../../Assets/Icons/tank.png';
import BuharKazaniIcon from '../../../Assets/Icons/BuharKazani.png';
import AydinlatmaIcon from '../../../Assets/Icons/Aydinlatma.png';
import DigerSistemlerIcon from '../../../Assets/Icons/DigerSistemler.png';
import SystemMonitoringIcon from '../../../Assets/Icons/SystemMonitoring.png';
import NotificationsIcon from '../../../Assets/Icons/Notifications.png';
import DevicesIcon from '../../../Assets/Icons/Devices.png';
import TagsIcon from '../../../Assets/Icons/Tags.png';
import WorkOrdersIcon from '../../../Assets/Icons/WorkOrders.png';
import WaterDropIcon from '../../../Assets/Icons/water-drop.png';
import HotWaterIcon from '../../../Assets/Icons/hot-water.png';
import ElektrikIcon from '../../../Assets/Icons/elektrik_renkli.png';

// Available icons list with labels
const availableIcons = [
  { src: DashboardIcon, label: 'Dashboard', name: 'Dashboard' },
  { src: TuketimTakibiIcon, label: 'Tüketim Takibi', name: 'TuketimTakibi' },
  { src: PompaVeHidroforIcon, label: 'Pompa & Hidrofor', name: 'PompaVeHidrofor' },
  { src: IsitmaSistemleriIcon, label: 'Isıtma Sistemleri', name: 'IsitmaSistemleri' },
  { src: SogutmaSistemleriIcon, label: 'Soğutma Sistemleri', name: 'SogutmaSistemleri' },
  { src: EnerjiIcon, label: 'Enerji', name: 'Enerji' },
  { src: VRFIcon, label: 'VRF', name: 'VRF' },
  { src: KlimaSantIcon, label: 'Klima Santral', name: 'KlimaSant' },
  { src: RooftopIcon, label: 'Rooftop', name: 'Rooftop' },
  { src: TankIcon, label: 'Tank / Depo', name: 'tank' },
  { src: BuharKazaniIcon, label: 'Buhar Kazanı', name: 'BuharKazani' },
  { src: AydinlatmaIcon, label: 'Aydınlatma', name: 'Aydinlatma' },
  { src: DigerSistemlerIcon, label: 'Diğer Sistemler', name: 'DigerSistemler' },
  { src: SystemMonitoringIcon, label: 'Sistem İzleme', name: 'SystemMonitoring' },
  { src: NotificationsIcon, label: 'Bildirimler', name: 'Notifications' },
  { src: DevicesIcon, label: 'Cihazlar', name: 'Devices' },
  { src: TagsIcon, label: 'Etiketler', name: 'Tags' },
  { src: WorkOrdersIcon, label: 'İş Emirleri', name: 'WorkOrders' },
  { src: WaterDropIcon, label: 'Su Damlası', name: 'water-drop' },
  { src: HotWaterIcon, label: 'Sıcak Su', name: 'hot-water' },
  { src: ElektrikIcon, label: 'Elektrik', name: 'elektrik_renkli' }
];

const PageIconSelector = ({ open, onClose, onSelect, currentIcon }) => {
  const [selectedIcon, setSelectedIcon] = useState(currentIcon || '');

  const handleIconClick = (iconSrc) => {
    setSelectedIcon(iconSrc);
  };

  const handleConfirm = () => {
    onSelect(selectedIcon);
    onClose();
  };

  const handleClear = () => {
    setSelectedIcon('');
    onSelect('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { minHeight: 400 }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Sayfa İkonu Seç</Typography>
          {selectedIcon && (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2" color="text.secondary">Seçili:</Typography>
              <img
                src={selectedIcon}
                alt="Selected"
                style={{ width: 32, height: 32, objectFit: 'contain' }}
              />
            </Box>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {availableIcons.map((icon, index) => (
            <Grid item xs={4} sm={3} md={2} key={index}>
              <Box
                onClick={() => handleIconClick(icon.src)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 1.5,
                  borderRadius: 2,
                  cursor: 'pointer',
                  border: selectedIcon === icon.src ? '2px solid #1976d2' : '2px solid transparent',
                  backgroundColor: selectedIcon === icon.src ? 'rgba(25, 118, 210, 0.1)' : 'transparent',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    border: '2px solid #ccc'
                  }
                }}
              >
                <img
                  src={icon.src}
                  alt={icon.label}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: 'contain',
                    marginBottom: 8
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    textAlign: 'center',
                    fontSize: '0.7rem',
                    lineHeight: 1.2,
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {icon.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          İptal
        </Button>
        <Button onClick={handleClear} color="secondary">
          Temizle
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Seç
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PageIconSelector;
